(ns frontend.ux-overhaul.table.view
  (:require
   [reagent.core :as r]
   ["ag-grid-react" :as ag-grid-react]
   [ui.components.grid.view :as grid]
   [oops.core :as oops]))

(defn adapt
  ([cls-name]
   (r/adapt-react-class (aget ag-grid-react cls-name)))
  ([parent-cls cls-name]
   (r/adapt-react-class (aget (aget ag-grid-react parent-cls) cls-name))))

(def ag-grid (adapt "AgGridReact"))

(defn get-cell-value
  [props]
  (try
    (let [get-cell-value-fn (oops/oget props "getCellValue")]
      (if (fn? get-cell-value-fn)
        (oops/ocall props "getCellValue")
        (aget props "value")))
    (catch js/Object _
      (aget props "value"))))

(defn view
  [{:keys [grid-id entity-type state-atom column-defs row-data
           width min-height on-selection-changed on-cell-edit-request tools auto-height? default-col-def
           on-row-drag-end row-selection enable-cell-text-selection no-rows-overlay-component suppress-context-menu]
    :as   props}]
  (let []
    (r/create-class
     {:component-did-mount (fn [_])
      :component-will-unmount (fn [_] nil)
      :reagent-render
      (fn
        [{:keys [grid-id entity-type state-atom column-defs row-data get-row-class
                 width max-height min-height on-selection-changed on-cell-edit-request tools auto-height? default-col-def
                 on-row-group-opened on-row-drag-move on-row-drag-end on-sort-changed suppress-row-drag
                 row-selection on-grid-ready! master-detail-options enable-cell-text-selection no-rows-overlay-component
                 get-row-style get-row-id]
          :as   props}]

        (let [on-grid-ready (fn [event]
                              (js/console.log "Native ag-grid on-grid-ready")
                              ; event and ref are really not the same,
                              ; but the event contains grid api and column api,
                              ; which are the same as the methods from grid ref
                              (swap! state-atom assoc-in [:grid :ref] event)
                              (when (fn? on-grid-ready!)
                                (on-grid-ready! event)))
              dom-layout (if auto-height?
                           "autoHeight"
                           "normal")]
          ^{:key (str "table" entity-type "-grid-" grid-id "-editable-")}
          [:div
           {:style {:max-width  width
                    :min-height min-height
                    :height     "100%"}}
           [:div
            {:style (merge {:max-height (or max-height "700px")
                            :min-height min-height
                            :width      "100%"}
                           (when-not auto-height?
                             {:height min-height}))}
            (when tools tools)
            [grid/ag-grid-enterprise
             (merge {:theme grid/theme-quartz
                     :columnDefs column-defs
                     :defaultColDef default-col-def
                     :rowData row-data
                     :getRowClass get-row-class
                     :resetRowDataOnUpdate true
                     :detailRowAutoHeight true
                     :domLayout dom-layout
                     :autoResizeColumns true
                     :rowBuffer 10
                     :onGridReady on-grid-ready
                     :enableSorting true
                     :suppressContextMenu (boolean suppress-context-menu)
                     :suppressColumnVirtualisation false
                     :suppressColumnMoveAnimation false
                     :suppressScrollOnNewData true
                     :suppressRowDrag suppress-row-drag
                     :pivotPanelShow "never"
                     :onToolPanelSizeChanged (fn [args] nil)
                     :enableCellTextSelection (if-not (nil? enable-cell-text-selection)
                                                enable-cell-text-selection
                                                "true")
                     :ensureDomOrder true
                     :animateRows true
                     :rowDeselection true
                     :groupDisplayType "multipleColumns"
                     :onSelectionChanged on-selection-changed
                     :onCellEditRequest on-cell-edit-request
                     :rowSelection {:mode "singleRow"
                                    :enableClickSelection true}
                     :onRowGroupOpened on-row-group-opened
                     :onRowDragMove on-row-drag-move
                     :onRowDragEnd on-row-drag-end
                     :onSortChanged on-sort-changed
                     :suppressDragLeaveHidesColumns true
                     :readOnlyEdit true
                     :stopEditingWhenCellsLoseFocus true
                     :noRowsOverlayComponent no-rows-overlay-component}
                    (when (fn? get-row-id)
                      {:getRowId get-row-id})
                    (when (fn? get-row-style)
                      {:getRowStyle get-row-style})
                    (when master-detail-options
                      (assoc master-detail-options
                             :masterDetail
                             true)))]]]))})))
